import { buildR2AssetsImageUrl } from "@saas/shared/lib/image-url-builder";
import {
	TRANSMISSION_5_DANCE_PARTNER_IMAGE,
	type Transmission5DanceQualityId,
} from "./transmission-5-dance-preset";

export interface Transmission5DanceShowcaseClip {
	id: string;
	quality: Transmission5DanceQualityId;
	orientation: "portrait";
	onSite: boolean;
	duration: number;
	videoUrl: string;
	previewVideoUrl: string;
	poster: string;
	hasAudio: boolean;
	inputImages: string[];
}

const R2_BASE = "home/showcase/transmission-5-dance";

/**
 * 本页工作台出的 HD 样片（库 cmvufsygd000dbu05jzj16og0、cmvug5ccv000lbu05ygz4sz0d），已核对 metadata.page 与扣费。
 * 工作台与下方样片区共用同一份 720p 文件。
 */
export const transmission5DanceShowcaseClips: Transmission5DanceShowcaseClip[] =
	[
		{
			id: "duo-one",
			inputImages: [
				buildR2AssetsImageUrl(`${R2_BASE}/refs/you.jpg`),
				TRANSMISSION_5_DANCE_PARTNER_IMAGE,
			],
		},
		{
			id: "duo-two",
			inputImages: [
				buildR2AssetsImageUrl("home/showcase/bulin-47/refs/man-1.jpg"),
				buildR2AssetsImageUrl(
					"home/showcase/bulin-47/refs/woman-1.jpg",
				),
			],
		},
	].map(({ id, inputImages }) => {
		const videoUrl = buildR2AssetsImageUrl(
			`${R2_BASE}/clips/${id}-720p.mp4`,
		);
		return {
			id,
			quality: "hd",
			orientation: "portrait",
			onSite: true,
			duration: 11.542,
			videoUrl,
			previewVideoUrl: videoUrl,
			poster: buildR2AssetsImageUrl(`${R2_BASE}/posters/${id}-720p.jpg`),
			hasAudio: true,
			inputImages,
		};
	});

/**
 * 原 reel（@nikitaenc0re × @el_diablork，取自 MakeViral 模板页，抓取 2026-10-30）：
 * 只放右栏 Examples 第 2 条，让人一眼认出梗；540×960 不到 720p，老公 10/30 同意例外。
 * 没有输入图，不出「Try this example」；onSite false，不进 VideoObject
 */
export const TRANSMISSION_5_DANCE_ORIGINAL_CLIP: Transmission5DanceShowcaseClip =
	{
		id: "original",
		quality: "hd",
		orientation: "portrait",
		onSite: false,
		duration: 11,
		videoUrl: buildR2AssetsImageUrl(`${R2_BASE}/clips/original.mp4`),
		previewVideoUrl: buildR2AssetsImageUrl(`${R2_BASE}/clips/original.mp4`),
		poster: buildR2AssetsImageUrl(`${R2_BASE}/posters/original.jpg`),
		hasAudio: true,
		inputImages: [],
	};

/** 两条本页 HD 样片的正式上传日期。 */
export const TRANSMISSION_5_DANCE_SHOWCASE_UPLOADED_AT =
	"2026-10-30T04:15:56+00:00";
